import type { LegalResult } from "@haulsheet/core";

export function LegalCheckList({ result }: { result: LegalResult }) {
  if (result.ok) {
    return (
      <div className="card legal-ok" data-testid="legal-check">
        Legal dims OK
      </div>
    );
  }
  return (
    <div className="card" data-testid="legal-check">
      <div className="stack">
        {result.flags.map((f) => (
          <div key={f.code} className="legal-flag">
            {f.message}
          </div>
        ))}
      </div>
    </div>
  );
}
